import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "../../../CoreComponent/Select";
import Input from "../../../CoreComponent/Input";
import DateInput from "../../../CoreComponent/Date";
import Checkbox from "../../../CoreComponent/Checkbox";
import { useAuth } from "../../../common/AuthContext";
import toast from "react-hot-toast";
import Dialog from "../../../CoreComponent/Dialog";
import SimpleLabelValue from "../../SimpleLabelValue";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const TripTypeOptions = [
  {
    value: "One-way trip from the airport to the hotel",
    label: "One-way trip from the airport to the hotel",
  },
  {
    value: "One-way trip from the hotel to the airport",
    label: "One-way trip from the hotel to the airport",
  },
  { value: "Round trip", label: "Round trip" },
];

const AirportTransferForm = () => {
  const { userId } = useAuth();
  const [id, setId] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    tripType: "",
    arrivalDate: "",
    arrivalTime: "",
    departureDate: "",
    departureTime: "",
    flightNumber: "",
    companionName: "",
    hasCompanion: false,
    fromLocation: "",
    toLocation: "",
    flight_booking_image: null,
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [bookingData, setBookingData] = useState(null);
  const [speakerTransportation, setSpeakerTransportation] = useState("");

  const {
    tripType,
    arrivalDate,
    arrivalTime,
    departureDate,
    departureTime,
    flightNumber,
    companionName,
    hasCompanion,
    fromLocation,
    toLocation,
    flight_booking_image,
  } = formData;

  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const normalizeTransportation = (value) => {
    return (value || "").toString().trim().toLowerCase();
  };

  const normalizeTrip = (value) => {
    return (value || "").toString().trim().toLowerCase();
  };

  const getSpeakerInfo = async () => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    try {
      const res = await axios.get(
        "https://eventscons.com/eventbackendnew/api/speakers/info",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const transportation =
        res?.data?.transportation ||
        res?.data?.data?.transportation ||
        res?.data?.speaker?.transportation ||
        "";

      setSpeakerTransportation(transportation);
      return res.data;
    } catch (error) {
      console.error("Speaker info error:", error);
      return null;
    }
  };

  const getTripPrice = (selectedTripType, apiTransportation) => {
    const trip = normalizeTrip(selectedTripType);
    const transportation = normalizeTransportation(apiTransportation);

    const isOneWay =
      trip.includes("one-way") || trip.includes("one way");

    const isRoundTrip =
      trip.includes("round trip") ||
      trip.includes("two way") ||
      trip.includes("two-way");

    const hasValidTransportation =
      transportation &&
      transportation !== "none";

    const apiIsTwoWays = transportation === "two ways";
    const apiIsOneWay = transportation === "one way";

    if (apiIsTwoWays) {
      return "0.00";
    }

    if (apiIsOneWay) {
      if (isOneWay) return "0.00";
      if (isRoundTrip) return "45.00";
    }

    if (!hasValidTransportation) {
      if (isOneWay) return "45.00";
      if (isRoundTrip) return "90.00";
    }

    return "45.00";
  };

  const getCurrentPrice = () => {
    return getTripPrice(tripType, speakerTransportation);
  };

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Token not found. Please log in again.");
      return;
    }

    try {
      await axios.delete(`${BaseUrl}/user/airport/delete`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Airport transfer booking has been deleted successfully.");
      setBookingData(null);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while deleting the booking.";
      toast.error(errorMessage);
    }
  };

  const handleChange = (field) => (value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, flight_booking_image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please login first");
      setLoading(false);
      return;
    }

    const url = isEdit
      ? `${BaseUrl}/airport-transfer-bookings/edit/${id}`
      : `${BaseUrl}/airport-transfer-bookings`;

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("userId", userId);
      formDataToSend.append("trip_type", tripType);
      formDataToSend.append("arrival_date", arrivalDate);
      formDataToSend.append("arrival_time", arrivalTime);
      formDataToSend.append("departure_date", departureDate);
      formDataToSend.append("departure_time", departureTime);
      formDataToSend.append("flight_number", flightNumber);
      formDataToSend.append("from_location", fromLocation);
      formDataToSend.append("to_location", toLocation);

      if (hasCompanion) {
        formDataToSend.append("companion_name", companionName);
      }
      if (flight_booking_image) {
        formDataToSend.append("flight_booking_image", flight_booking_image);
      }

      await axios.post(url, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const currentPrice = getCurrentPrice();

      toast.success("Request submitted successfully! 🎉");
      setInvoiceData({ total_price: currentPrice, status: "pending" });
      setOpen(true);

      setFormData({
        tripType: "",
        arrivalDate: "",
        arrivalTime: "",
        departureDate: "",
        departureTime: "",
        flightNumber: "",
        companionName: "",
        hasCompanion: false,
        fromLocation: "",
        toLocation: "",
        flight_booking_image: null,
      });
      setPreviewImage(null);
      setIsEdit(false);

      setTimeout(() => {
        getBooking();
      }, 1500);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "An error occurred while submitting the request.";
      toast.error(errorMessage);
      console.error("Submit error:", error);
    } finally {
      setLoading(false);
    }
  };

  const getBooking = () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`${BaseUrl}/user/airport-transfer-bookings`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const updatedBookings = (response.data || []).map((booking) => ({
          ...booking,
          invoice: {
            ...booking.invoice,
            total_price: getTripPrice(booking.trip_type, speakerTransportation),
            status: booking.invoice?.status || "pending",
          },
        }));

        setBookingData(updatedBookings);
        const data2 = updatedBookings?.[0];
        if (data2) {
          setId(data2?.id);
          setFormData({
            tripType: data2?.trip_type || "",
            arrivalDate: data2?.arrival_date || "",
            arrivalTime: data2?.arrival_time || "",
            departureDate: data2?.departure_date || "",
            departureTime: data2?.departure_time || "",
            flightNumber: data2?.flight_number || "",
            companionName: data2?.companion_name || "",
            hasCompanion: !!data2?.companion_name,
            fromLocation: data2?.from_location || "",
            toLocation: data2?.to_location || "",
            flight_booking_image: null,
          });
        }
      })
      .catch((error) => {
        console.error("Get booking error:", error);
      });
  };

  useEffect(() => {
    getSpeakerInfo();
    getBooking();
  }, []);

  const handlePayment = async () => {
    const type = "airport";
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const amount = invoiceData?.total_price || getCurrentPrice();

      if (!amount || amount === "0.00") {
        toast.success("No payment required.");
        return;
      }

      const response = await axios.post(
        `${BaseUrl}/paypal/create-payment`,
        {
          amount,
          return_url: `https://eventscons.com/success/${type}/${id}/0`,
          cancel_url: `https://eventscons.com/failed`,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const orderID = response.data.id;
      window.location.href = `https://www.paypal.com/checkoutnow?token=${orderID}`;
    } catch (error) {
      toast.error("Payment initiation failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDialogClose = () => {
    setOpen(false);
    setInvoiceData(null);
  };

  const currentPrice = getCurrentPrice();
  const showPayNow = currentPrice !== "0.00";

  return (
    <div className="airport-transfer-form-section">
      {!bookingData || bookingData.length === 0 || isEdit ? (
        <div className="airport-transfer-form">
          <form
            className="airport-transfer-form-container"
            onSubmit={handleSubmit}
          >
            <h3>Airport Transfer Requests</h3>

            <Select
              options={TripTypeOptions}
              value={{ value: tripType, label: tripType }}
              setValue={(option) => handleChange("tripType")(option.value)}
              label="Trip Type"
            />

            <DateInput
              label="Arrival Date"
              inputValue={arrivalDate}
              setInputValue={handleChange("arrivalDate")}
              required
            />

            <DateInput
              label="Arrival Time"
              inputValue={arrivalTime}
              setInputValue={handleChange("arrivalTime")}
              placeholder="Enter Arrival Time"
              type="time"
              required
            />

            <DateInput
              label="Departure Date"
              inputValue={departureDate}
              setInputValue={handleChange("departureDate")}
              placeholder="Enter Departure Date"
              type="date"
            />

            <DateInput
              label="Departure Time"
              inputValue={departureTime}
              setInputValue={handleChange("departureTime")}
              placeholder="Enter Departure Time"
              type="time"
            />

            <Input
              label="Flight Number"
              inputValue={flightNumber}
              setInputValue={handleChange("flightNumber")}
              placeholder="Enter Flight Number"
              required
            />

            <Input
              label="From Location"
              inputValue={fromLocation}
              setInputValue={handleChange("fromLocation")}
              placeholder="Enter from location"
              required
            />

            <Input
              label="To Location"
              inputValue={toLocation}
              setInputValue={handleChange("toLocation")}
              placeholder="Enter to location"
              required
            />

            <Checkbox
              label="Do you have a companion?"
              checkboxValue={hasCompanion}
              setCheckboxValue={handleChange("hasCompanion")}
            />

            {hasCompanion && (
              <Input
                label="Companion Name"
                inputValue={companionName}
                setInputValue={handleChange("companionName")}
                placeholder="Enter Companion's Name"
              />
            )}

            <div className="file-upload">
              <label>Flight Ticket Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{ marginTop: "10px", width: "200px", height: "auto" }}
                />
              )}
            </div>

            <div className="form-action">
              <button
                type="submit"
                className="submit-btn"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>

          <Dialog
            viewHeader={true}
            header="Invoice"
            open={open}
            setOpen={handleDialogClose}
            children={
              invoiceData && (
                <div className="invoice-section">
                  <p>
                    <strong>Total Price: ${invoiceData.total_price}</strong>
                  </p>

                  <div className="dialog-actions">
                    {showPayNow && (
                      <button
                        className="pay-btn"
                        onClick={handlePayment}
                        disabled={loading}
                      >
                        {loading
                          ? "Processing..."
                          : `Pay Now ($${invoiceData.total_price})`}
                      </button>
                    )}

                    <button
                      className="cancel-btn"
                      onClick={handleDialogClose}
                    >
                      Close
                    </button>
                  </div>
                </div>
              )
            }
          />
        </div>
      ) : (
        <div className="booking-data">
          {bookingData?.map((booking) => {
            const bookingPrice = getTripPrice(
              booking.trip_type,
              speakerTransportation
            );
            const bookingShowPayNow = bookingPrice !== "0.00";

            return (
              <div key={booking.id} className="booking-card">
                <div className="booking-details">
                  <h4>Booking Details</h4>
                  <div className="booking-details-list">
                    <SimpleLabelValue label="Trip Type" value={booking.trip_type} />
                    <SimpleLabelValue label="Arrival Date" value={booking.arrival_date} />
                    <SimpleLabelValue label="Arrival Time" value={booking.arrival_time} />
                    <SimpleLabelValue label="Departure Date" value={booking.departure_date} />
                    <SimpleLabelValue label="Departure Time" value={booking.departure_time} />
                    <SimpleLabelValue label="Flight Number" value={booking.flight_number} />
                    <SimpleLabelValue label="From Location" value={booking.from_location} />
                    <SimpleLabelValue label="To Location" value={booking.to_location} />
                  </div>
                </div>

                <div className="invoice-details">
                  <h4>Invoice</h4>
                  {booking.invoice ? (
                    <div className="invoice-details-list">
                      <SimpleLabelValue
                        label="Total Price (USD)"
                        value={`$${bookingPrice}`}
                      />
                      <SimpleLabelValue
                        label="Status"
                        value={booking.invoice.status}
                      />

                      {bookingShowPayNow && booking.invoice.status !== "approved" && (
                        <button
                          className="pay-btn"
                          onClick={() => {
                            setInvoiceData({
                              total_price: bookingPrice,
                              status: booking.invoice?.status || "pending",
                            });
                            handlePayment();
                          }}
                        >
                          Pay Now (${bookingPrice})
                        </button>
                      )}

                      <button
                        className="pay-btn edit-btn"
                        onClick={() => {
                          setIsEdit(true);
                        }}
                      >
                        Edit
                      </button>
                      <button className="pay-btn delete-btn" onClick={handleDelete}>
                        Delete
                      </button>
                    </div>
                  ) : (
                    <p>No invoice available</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AirportTransferForm;